// extracted by mini-css-extract-plugin
export var banner = "_rc-0";
export var settingRow = "_rc-2";
export var titleIcon = "_rc-1";